import { useEffect, useState } from "react";
import { startTranslator } from "@/lib/i18n";

const KEY = "gf_lang";
const EVT = "gf-lang-change";

export const getLang = () => {
  try {
    const v = localStorage.getItem(KEY);
    if (v && v !== "en") return v;
    if (v === "en") return "en";
  } catch {}
  const m = document.cookie.match(/(?:^|;\s*)gf_lang=([a-z]{2})/);
  return m ? m[1] : "en";
};

export const setLang = (lang) => {
  try { localStorage.setItem(KEY, lang); } catch {}
  document.cookie = `gf_lang=${lang}; path=/; max-age=31536000; SameSite=Lax`;
  document.documentElement.lang = lang;
  startTranslator(lang);
  window.dispatchEvent(new CustomEvent(EVT, { detail: lang }));
};

export const useLang = () => {
  const [lang, set] = useState(getLang);
  useEffect(() => {
    const on = (e) => set(e.detail);
    window.addEventListener(EVT, on);
    return () => window.removeEventListener(EVT, on);
  }, []);
  return lang;
};

// English ↔ Hindi twin paths for the translated families
export const hindiTwin = (pathname) => {
  if (pathname === "/") return { base: "home", slug: "home", to: "/hi" };
  if (pathname === "/marketpulse" || pathname === "/market-pulse") return { base: "marketpulse", slug: "market-pulse", to: "/hi/marketpulse" };
  const m = pathname.match(/^\/(coreservices|insights|podcast)\/([^/]+)$/);
  return m ? { base: m[1], slug: m[2], to: `/hi/${m[1]}/${m[2]}` } : null;
};
export const englishTwin = (pathname) => (pathname === "/hi" ? "/" : pathname.startsWith("/hi/") ? pathname.slice(3) : null);

// Deep-merge a translated copy object over its English source (arrays only replace when lengths match)
export const mergeCopy = (base, over) => (Array.isArray(base)
  ? (Array.isArray(over) && over.length === base.length ? over : base)
  : typeof base === "object" && base
    ? Object.fromEntries(Object.entries(base).map(([k, v]) => [k, over && over[k] !== undefined ? mergeCopy(v, over[k]) : v]))
    : (typeof over === "string" && over ? over : base));
